import { useEffect } from "react";
import React from 'react';
import Dreamhash from '../images/projects/dreamhash.png';
import Artton from '../images/projects/artton.png';
import AVR from '../images/projects/AVR.png';
import kheeddo from '../images/projects/kheeddo.png';
import Metromedi from '../images/projects/metromedi.png';
import MSA from '../images/projects/MSA.png';
import Premier from '../images/projects/premier-pumps.jpg';
import Helishores from '../images/projects/helishores.png';
import OMG from '../images/projects/One-More-Game.png';
import Quatz from '../images/projects/Quatz.png';
import RD from '../images/projects/RD.png';
import SAS from '../images/projects/Srinivasa-Agro-Seeds.png';
import SST from '../images/projects/SST.png';
import Durgi from '../images/projects/durgi-millets.png';
import BR from '../images/projects/BR.png';
import Skand from '../images/projects/skand.png';
import Nichesoft from '../images/projects/nichesoft.png';
import Tattva from '../images/projects/tattva.png';
import HelpMed from '../images/projects/helpmed.png';







function Portfolio() {
     // ✅ Put useEffect HERE — inside the component
  useEffect(() => {
    const boxes = document.querySelectorAll(".even-box");

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add("scrolled");
          } else {
            entry.target.classList.remove("scrolled");
          }
        });
      },
      {
        threshold: 0.1,
      }
    );

    boxes.forEach(box => observer.observe(box));

    return () => {
      boxes.forEach(box => observer.unobserve(box));
    };
  }, []);

    return (
        <div className="">
            {/* Hero Section Starts */}
            <div className="about-hero d-flex align-items-center">
                <div className="about-hero-inner container">
                    <div className="hero-content">
                        <h2 className="hero-title title display-3">Portfolio</h2>
                        <p>Home / Portfolio</p>
                    </div>
                </div>
            </div>
            {/* Hero Section Ends */}
            {/* <!-- portfolio start  --> */}
            <section className="container-fluid py-5 bg-light-gray">
                <div className="container">
                    <div className="title-part d-flex align-items-center justify-content-center flex-column mb-5">
                        <h5 className="mb-3 title fw-bold fs-4 text-center OUR WORK HIGHLIGHTS">OUR WORK HIGHLIGHTS</h5>
                        <h1 className="text-center display-4 ">Explore Our Portfolio</h1>
                    </div>

                    <div className="row">
                        <div className="col-lg-6 col-md-6  even-box">
                            <div className="p-lg-4">
                                <a className="text-decoration-none" href="https://tattvarealty.co.in/" target="_blank">
                                    <div className="portfolio-img-container p-lg-4 p-3 rounded-5 mb-4">
                                        <img className="img-fluid rounded-5" src={Tattva} alt="" />
                                    </div>
                                    <div className="portfolio-text-part">
                                        <h3 className="mb-3 title fw-bold fs-4 text-center">TATTVA REALTY & INFRA</h3>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6  even-box">
                            <div className="p-lg-4">
                                <a className="text-decoration-none" href="https://helpmedsolution.com/" target="_blank">
                                    <div className="portfolio-img-container p-lg-4 p-3 rounded-5 mb-4">
                                        <img className="img-fluid rounded-5" src={HelpMed} alt="" />
                                    </div>
                                    <div className="portfolio-text-part">
                                        <h3 className="mb-3 title fw-bold fs-4 text-center">HELPMED SOLUTIONS</h3>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6  even-box">
                            <div className="p-lg-4">
                                <a className="text-decoration-none" href="https://premierpumps.net/" target="_blank">
                                    <div className="portfolio-img-container p-lg-4 p-3 rounded-5 mb-4">
                                        <img className="img-fluid rounded-5" src={Premier} alt="" />
                                    </div>
                                    <div className="portfolio-text-part">
                                        <h3 className="mb-3 title fw-bold fs-4 text-center">PREMIER PUMPS</h3>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 even-box">
                            <div className="p-lg-4">
                                <a className="text-decoration-none" href="https://helishores.com/" target="_blank">
                                    <div className="portfolio-img-container p-lg-4 p-3 rounded-5 mb-4">
                                        <img className="img-fluid rounded-5" src={Helishores} alt="" />
                                    </div>
                                    <div className="portfolio-text-part">
                                        <h3 className="mb-3 title fw-bold fs-4 text-center">HELISHORES</h3>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6  even-box">
                            <div className="p-lg-4">
                                <a className="text-decoration-none" href="https://nichesoft.ai/" target="_blank">
                                    <div className="portfolio-img-container p-lg-4 p-3 rounded-5 mb-4">
                                        <img className="img-fluid rounded-5" src={Nichesoft} alt="" />
                                    </div>
                                    <div className="portfolio-text-part">
                                        <h3 className="mb-3 title fw-bold fs-4 text-center">NICHESOFT</h3>
                                        {/* <p className="fs-3 title text-center">Sri Sumukha Travels - Created using WordPress</p> */}
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6  even-box">
                            <div className="p-lg-4">
                                <a className="text-decoration-none" href="https://skandsolutions.com/" target="_blank">
                                    <div className="portfolio-img-container p-lg-4 p-3 rounded-5 mb-4">
                                        <img className="img-fluid rounded-5" src={Skand} alt="" />
                                    </div>
                                    <div className="portfolio-text-part">
                                        <h3 className="mb-3 title fw-bold fs-4 text-center">SKAND EXIM</h3>
                                        {/* <p className="fs-3 title text-center">Srinivasa Agro Seeds - Created using WordPress</p> */}
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6  even-box">
                            <div className="p-lg-4">
                                <a className="text-decoration-none" href="https://msamotors.in/" target="_blank">
                                    <div className="portfolio-img-container p-lg-4 p-3 rounded-5 mb-4">
                                        <img className="img-fluid rounded-5" src={MSA} alt="" />
                                    </div>
                                    <div className="portfolio-text-part">
                                        <h3 className="mb-3 title fw-bold fs-4 text-center">MSA MOTORS</h3>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 even-box">
                            <div className="p-lg-4">
                                <a className="text-decoration-none" href="https://metromedi.com/" target="_blank">
                                    <div className="portfolio-img-container p-lg-4 p-3 rounded-5 mb-4">
                                        <img className="img-fluid rounded-5" src={Metromedi} alt="" />
                                    </div>
                                    <div className="portfolio-text-part">
                                        <h3 className="mb-3 title fw-bold fs-4 text-center">METROMEDI</h3>
                                        {/* <p className="fs-3 title text-center">METROMEDI - Created using WordPress</p> */}
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6  even-box">
                            <div className="p-lg-4">
                                <a className="text-decoration-none" href="https://quatz.com.au/" target="_blank">
                                    <div className="portfolio-img-container p-lg-4 p-3 rounded-5 mb-4">
                                        <img className="img-fluid rounded-5" src={Quatz} alt="" />
                                    </div>
                                    <div className="portfolio-text-part">
                                        <h3 className="mb-3 title fw-bold fs-4 text-center">QUATZ</h3>
                                        {/* <p className="fs-3 title text-center">Quatz - Created using WordPress</p> */}
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 even-box">
                            <div className="p-lg-4">
                                <a className="text-decoration-none" href="https://avrinfradevelopers.com/" target="_blank">
                                    <div className="portfolio-img-container p-lg-4 p-3 rounded-5 mb-4">
                                        <img className="img-fluid rounded-5" src={AVR} alt="" />
                                    </div>
                                    <div className="portfolio-text-part">
                                        <h3 className="mb-3 title fw-bold fs-4 text-center">AVR INFRA DEVELOPERS</h3>
                                        {/* <p className="fs-3 title text-center">AVR Infra - Created using WordPress</p> */}
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6  even-box">
                            <div className="p-lg-4">
                                <a className="text-decoration-none" href="https://dreamhash.in/" target="_blank">
                                    <div className="portfolio-img-container p-lg-4 p-3 rounded-5 mb-4">
                                        <img className="img-fluid rounded-5" src={Dreamhash} alt="" />
                                    </div>
                                    <div className="portfolio-text-part">
                                        <h3 className="mb-3 title fw-bold fs-4 text-center">DREAMHASH</h3>
                                        {/* <p className="fs-3 title text-center">DREAMHASH - Created using WordPress</p> */}
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 even-box">
                            <div className="p-lg-4">
                                <a className="text-decoration-none" href="https://durgimillets.com/" target="_blank">
                                    <div className="portfolio-img-container p-lg-4 p-3 rounded-5 mb-4">
                                        <img className="img-fluid rounded-5" src={Durgi} alt="" />
                                    </div>
                                    <div className="portfolio-text-part">
                                        <h3 className="mb-3 title fw-bold fs-4 text-center">DURGI MILLETS</h3>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6  even-box">
                            <div className="p-lg-4">
                                <a className="text-decoration-none" href="https://www.onemoregame.in/" target="_blank">
                                    <div className="portfolio-img-container p-lg-4 p-3 rounded-5 mb-4">
                                        <img className="img-fluid rounded-5" src={OMG} alt="" />
                                    </div>
                                    <div className="portfolio-text-part">
                                        <h3 className="mb-3 title fw-bold fs-4 text-center">ONE MORE GAME</h3>
                                        {/* <p className="fs-3 title text-center">One More Game - Created using WordPress</p> */}
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6  even-box">
                            <div className="p-lg-4">
                                <a className="text-decoration-none" href="https://srinivasaagroseeds.com/" target="_blank">
                                    <div className="portfolio-img-container p-lg-4 p-3 rounded-5 mb-4">
                                        <img className="img-fluid rounded-5" src={SAS} alt="" />
                                    </div>
                                    <div className="portfolio-text-part">
                                        <h3 className="mb-3 title fw-bold fs-4 text-center">SRINIVASA AGRO SEEDS</h3>
                                        {/* <p className="fs-3 title text-center">Srinivasa Agro Seeds - Created using WordPress</p> */}
                                    </div>
                                </a>
                            </div>
                        </div>
                        {/* <div className="col-lg-6 col-md-6">
                            <div className="p-lg-4">
                                <a className="text-decoration-none" href="https://sreesumukhatravels.com/" target="_blank">
                                    <div className="portfolio-img-container p-lg-4 p-3 rounded-5 mb-4">
                                        <img className="img-fluid rounded-5" src={SST} alt="" />
                                    </div>
                                    <div className="portfolio-text-part">
                                        <h3 className="mb-3 title fw-bold fs-4 text-center">SRI SUMUKHA TRAVELS</h3>
                                    </div>
                                </a>
                            </div>
                        </div> */}
                        {/* <div className="col-lg-6 col-md-6  ">
                            <div className="p-lg-4">
                                <a className="text-decoration-none" href="https://brprecision.com/" target="_blank">
                                    <div className="portfolio-img-container p-lg-4 p-3 rounded-5 mb-4">
                                        <img className="img-fluid rounded-5" src={BR} alt="" />
                                    </div>
                                    <div className="portfolio-text-part">
                                        <h3 className="mb-3 title fw-bold fs-4 text-center">BR PRECESION</h3>
                                    </div>
                                </a>
                            </div>
                        </div> */}
                        
                    </div>
                </div>

            </section >

            {/* <!-- portfolio end  --> */}
        </div >
    )
}

export default Portfolio